module.exports = __webpack_public_path__ + "img/reload.7470ee2e.svg";